import { render, staticRenderFns } from "./BusinessModuleEdit.vue?vue&type=template&id=1f8c7652&"
import script from "./BusinessModuleEdit.vue?vue&type=script&lang=js&"
export * from "./BusinessModuleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports